import arrowLeft from './arrow-left.svg?sprite';
import arrowRight from './arrow-right.svg?sprite';
import arrowStrongRight from './arrow-strong-right.svg?sprite';
import cameraOutline from './camera-outline.svg?sprite';
import cartH24 from './h24/cart.svg?sprite';
import cartFfh from './ffh/cart.svg?sprite';
import checkboxActive from './checkbox/checkbox-active.svg?sprite';
import checkboxCheckedInactive from './checkbox/checkbox-checked-inactive.svg?sprite';
import checkboxDefault from './checkbox/checkbox-default.svg?sprite';
import checkboxInactive from './checkbox/checkbox-inactive.svg?sprite';
import close from './close.svg?sprite';
import closeStrong from './close-strong.svg?sprite';
import closeStrongSmall from './close-strong-small.svg?sprite';
import copy from './copy.svg?sprite';
import edit from './edit.svg?sprite';
import error from './error.svg?sprite';
import facebook from './facebook.svg?sprite';
import filteringSorting from './filtering-sorting.svg?sprite';
import history from './history.svg?sprite';
import info from './info.svg?sprite';
import invisible from './invisible.svg?sprite';
import instagram from './instagram.svg?sprite';
import landscapeOutline from './landscape-outline.svg?sprite';
import lightCheck from './light-check.svg?sprite';
import list from './list.svg?sprite';
import materials from './materials.svg?sprite';
import minus from './minus.svg?sprite';
import plus from './plus.svg?sprite';
import plusStrong from './plus-strong.svg?sprite';
import play from './play.svg?sprite';
import radioDefault from './radio-default.svg?sprite';
import radioSelected from './radio-selected.svg?sprite';
import returnCircle from './return.svg?sprite';
import security from './security.svg?sprite';
import spinner from './spinner.svg?sprite';
import subscribe from './subscribe.svg?sprite';
import success from './success.svg?sprite';
import truck from './truck.svg?sprite';
import visible from './visible.svg?sprite';
import warning from './warning.svg?sprite';
import wishlist from './wishlist.svg?sprite';
export default {
    arrowLeft: arrowLeft,
    arrowRight: arrowRight,
    arrowStrongRight: arrowStrongRight,
    cameraOutline: cameraOutline,
    cartH24: cartH24,
    cartFfh: cartFfh,
    checkboxActive: checkboxActive,
    checkboxCheckedInactive: checkboxCheckedInactive,
    checkboxDefault: checkboxDefault,
    checkboxInactive: checkboxInactive,
    close: close,
    closeStrongSmall: closeStrongSmall,
    closeStrong: closeStrong,
    copy: copy,
    edit: edit,
    error: error,
    facebook: facebook,
    filteringSorting: filteringSorting,
    history: history,
    info: info,
    invisible: invisible,
    instagram: instagram,
    landscapeOutline: landscapeOutline,
    lightCheck: lightCheck,
    list: list,
    materials: materials,
    minus: minus,
    play: play,
    plus: plus,
    plusStrong: plusStrong,
    radioDefault: radioDefault,
    radioSelected: radioSelected,
    returnCircle: returnCircle,
    security: security,
    spinner: spinner,
    subscribe: subscribe,
    success: success,
    truck: truck,
    visible: visible,
    warning: warning,
    wishlist: wishlist,
};
